














































import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { ContentSet, isContentSetSubjectDetails } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { isFileSubjectDetails } from "@scrile/api-provider/dist/api/FileProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { CurrencyCost } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import {
  EventPost,
  EventPostStatus,
  isEventSubjectDetails,
} from "@scrile/api-provider/dist/projects/scrileConnect/EventPostProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getMainCurrencyCode } from "@/lib/moneyHelpers";
import { formatDate } from "@/lib/time";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseImage from "@/components/BaseImage";
import ContentFeedCover from "@/components/ContentFeedCover";
import FormatMoney from "@/components/FormatMoney";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationContentPurchase",
  components: { NotificationItemView, ContentFeedCover, FormatMoney, BaseIcon, BaseImage },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup(props) {
    const isContentSet = computed<boolean>(() => {
      return isContentSetSubjectDetails(props.notification.details.content);
    });
    const isEvent = computed<boolean>(() => {
      return isEventSubjectDetails(props.notification.details.content);
    });
    const isFile = computed<boolean>(() => {
      return isFileSubjectDetails(props.notification.details.content);
    });
    const contentSet = computed<ContentSet | null>(() => {
      return props.notification.details.content.contentSet;
    });
    const event = computed<EventPost | null>(() => {
      return props.notification.details.content.event;
    });
    const showEventIcon = computed<boolean>(() => {
      return (
        event.value?.status === EventPostStatus.PUBLISHED ||
        event.value?.status === EventPostStatus.READY_TO_START ||
        event.value?.status === EventPostStatus.STARTED
      );
    });
    const messageType = computed(() => {
      return isFile.value ? "soldAttachment" : isEvent.value ? "soldEvent" : "soldPost";
    });

    const { authUserStrict } = useAuthUser();
    const subjectUrl = computed<Location>(() => {
      if (isContentSet.value || isEvent.value) {
        return getProfileUrl(authUserStrict.value, { feedId: props.notification.subjectId });
      }
      return {
        name: "messages",
        params: { userId: props.notification.userId },
      };
    });

    const subjectSrc = computed<string>(() => {
      if (!isFile.value) return "";

      const file = props.notification.details.content.file;
      return isVideoFile(file)
        ? MediaFilesController.getVideoThumbnail(file.urlPart, 112)
        : MediaFilesController.getImageThumbnail(file.urlPart, 112);
    });

    const price = computed<number | null>(() => {
      const costs = props.notification.details.costs;
      return costs.find((cost: CurrencyCost) => cost.currency === getMainCurrencyCode())?.cost ?? null;
    });

    const date = computed<string>(() =>
      formatDate(new Date(event.value?.time || ""), {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      })
    );

    return {
      isFile,
      isEvent,
      isContentSet,
      contentSet,
      event,
      price,
      date,
      subjectUrl,
      subjectSrc,
      messageType,
      showEventIcon,
    };
  },
});
